// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { RequirePermission } from "@/components/shared/require-permission";
import { PiiMarkerList } from "@/features/hardware/pii-marker/pii-marker-list";
import { PAGE_PERMISSIONS } from "@/lib/auth/page-permissions";

export const Route = createFileRoute("/_authenticated/hardware/pii-marker/")({
  // Deep links straight into an editor, e.g. from support tickets
  validateSearch: z.object({
    image: z.coerce.number().int().positive().optional(),
    camera: z.coerce.number().int().positive().optional(),
  }),
  component: PiiMarkerPage,
});

function PiiMarkerPage() {
  const { image, camera } = Route.useSearch();
  const navigate = useNavigate();
  const initialTarget = image ? { imageId: image } : camera ? { cameraId: camera } : undefined;
  return (
    <RequirePermission permission={PAGE_PERMISSIONS.hardwarePiiMarker}>
      <PiiMarkerList
        initialTarget={initialTarget}
        onDialogClosed={() => {
          if (image || camera) navigate({ to: "/hardware/pii-marker", search: {}, replace: true });
        }}
      />
    </RequirePermission>
  );
}
